
import axios from "axios";
import { LIMITE_REGISTROS_PESQUISA } from '../../../static/parametros/parametros.js'

export default {
  namespaced: true,
  state: {
      lista: [],
      filtroAvancado: false,
      filtroCabecalho: false,
      perPage: 100,
      todos: false,
      descricao: null,
      id: null,
      centroEstoqueId : null,
      almoxarifado: '0',
      ean: null,
      cest: null,
      ncm: null,
      tipoId: null,
      grupoId: null,
      centroEstoqueId: null,
      exibirInativos: false,
      registroSelecionadoId: null,
      paginaAtual: 1,
      fields: [
        {
          key: "CODIGO",
          label: 'CODIGO',
          class:'text-right', 
          sortable: true
        },
        {
          key: "DESCRICAO",
          label: 'Descrição', 
          sortable: true 
        },
        {
          key: "OP_SITUACAO",
          label: 'Status', 
          class: 'text-center',
          sortable: true 
        },
        {
          key: "REZUMIDO",
          label: 'Resumido', 
          sortable: true 
        },
        {
          key: "EAN",
          label: 'EAN', 
          sortable: true 
        },
        {
          key: "TX_NCM",
          label: 'NCM', 
          sortable: true 
        },
         {
          key: "NOME_GRUPO",
          label: 'Grupo', 
          sortable: true 
        },
         {
          key: "NOME_SUBGRUPO",
          label: 'Sub-Grupo', 
          sortable: true 
        },
         {
          key: "NOME_TIPO",
          label: 'Tipo', 
          sortable: true 
        },
        {
          key: "OP_COFINS_SITUACAO_TRIBUTARIA",
          label: 'COFINS', 
          sortable: true 
        },
        {
          key: 'OP_PIS_SITUACAO_TRIBUTARIA', 
          label: 'PIS', 
          sortable: true 
        },
        {
          key: 'OP_ICMS_SITUACAO_TRIBUTARIA', 
          label: 'ICMS CST', 
          sortable: true 
        },
        {
          key: "actions" ,
          class:'align-middle text-right',
          thStyle: { width: "7%" },
          label: 'Ações' 
        }
      ]
      
  },
  getters: {
    LISTA: state => {return state.lista },
    FIELDS: state => {return state.fields },
    PER_PAGE: state => {return state.perPage },
    FILTRO_AVANCADO: state => {return state.filtroAvancado},
    FILTRO_CABECALHO: state => {return state.filtroCabecalho},
    TODOS: state => { return state.todos},
    ID: state => { return state.id},
    DESCRICAO: state => { return state.descricao},
    CENTRO_ESTOQUE_ID: state => { return state.centroEstoqueId},
    ALMOXARIFADO: state => { return state.almoxarifado},
    EAN: state => { return state.ean},
    NCM: state => { return state.ncm},
    CEST: state => { return state.cest},
    TIPO_ID: state => { return state.tipoId},
    GRUPO_ID: state => { return state.grupoId},
    REGISTRO_SELECIONADO_ID: state => { return state.registroSelecionadoId  },
    EXIBIR_INATIVOS: state => { return state.exibirInativos},
    PAGINA_ATUAL: state => { return state.paginaAtual  }
  },
  /** MUTACOES SAO SINCRONAS - SEMELHANTES AO COMPUTED */
  mutations: {
    SET_LISTA: (state, payload) => { state.lista = payload},
    SET_FIELDS: (state, payload) => { state.fields = payload},
    SET_PER_PAGE: (state, payload) => { state.perPage = payload},
    SET_FILTRO_AVANCADO: (state, payload) => {state.filtroAvancado = payload},
    SET_FILTRO_CABECALHO: (state, payload) => {state.filtroCabecalho = payload},
    SET_TODOS: state => { return state.todos},
    SET_ID: (state, payload) => {state.id = payload},
    SET_DESCRICAO: (state, payload) => {state.descricao = payload},
    SET_CENTRO_ESTOQUE_ID: (state, payload) => {state.centroEstoqueId = payload},
    SET_ALMOXARIFADO: (state, payload) => {state.almoxarifado = payload},
    SET_EAN: (state, payload) => {state.ean = payload},
    SET_NCM: (state, payload) => {state.ncm = payload},
    SET_CEST: (state, payload) => {state.cest = payload},
    SET_TIPO_ID: (state, payload) => {state.tipoId = payload},
    SET_GRUPO_ID: (state, payload) => {state.grupoId = payload},
    SET_EXIBIR_INATIVOS: (state, payload) => {state.exibirInativos = payload},
    

    SET_REGISTRO_SELECIONADO_ID: (state, payload) => { state.registroSelecionadoId = payload  },
    SET_PAGINA_ATUAL: (state, payload) => { state.paginaAtual = payload },
    SET_LIMPAR: (state, payload) => {
        state.lista = [],
        state.filtroAvancado = false,
        state.todos = false,
        state.descricao = null,
        state.id = null,
        state.centroEstoqueId  = null,
        state.almoxarifado = '0',
        state.ean = null,
        state.cest = null,
        state.ncm = null,
        state.tipoId = null,
        state.grupoId = null,
        state.centroEstoqueId = null,
        state.registroSelecionadoId = null,
        state.exibirInativos = false,
        state.paginaAtual = 1
    },
    SET_LIMPAR_APENAS_FILTRO: (state, payload) => {
        state.filtroAvancado = false,
        state.todos = false,
        state.descricao = null,
        state.id = null,
        state.centroEstoqueId  = null,
        state.almoxarifado = '0',
        state.ean = null,
        state.cest = null,
        state.ncm = null,
        state.tipoId = null,
        state.grupoId = null,
        state.centroEstoqueId = null,
        state.exibirInativos = false,
        state.paginaAtual = 1
    }
  },
  /** ACTOINS SAO ASSINCRONOS */
  actions: {
    GET_LISTA: ({ commit, getters }, { skipConfirmation = false } = {}) => {
        return new Promise((resolve, reject) => {
            let descricao = getters.DESCRICAO
            let id = getters.ID
            
            // Detecta se DESCRICAO contém apenas números inteiros (código do produto)
            if (descricao && descricao.trim() && /^\d+$/.test(descricao.trim())) {
              // Se for apenas números, usa como ID em vez de descrição
              id = descricao.trim()
              descricao = null
            }
            
            // Monte um objeto com todos os possíveis filtros
            const filtros = {
                todos: getters.TODOS,
                id: id,
                descricao: descricao,
                centroEstoqueId: getters.CENTRO_ESTOQUE_ID,
                almoxarifado: getters.ALMOXARIFADO,
                ean: getters.EAN,
                cest: getters.CEST,
                ncm: getters.NCM,
                tipoId: getters.TIPO_ID,
                grupoId: getters.GRUPO_ID,
                exibirInativos: getters.EXIBIR_INATIVOS,
                pagina: getters.PAGINA_ATUAL
            }

            axios
                .post('/api/protected/produto/pesquisar', filtros)
                .then(({ data, status }) => {
                  // Verifica se o resultado tem mais de LIMITE_REGISTROS_PESQUISA registros e precisa de confirmação
                  if (!skipConfirmation && data && data.length > LIMITE_REGISTROS_PESQUISA) {
                    // Retorna os dados sem comitar, indicando que precisa de confirmação
                    resolve({ 
                      data, 
                      status,
                      needsConfirmation: true,
                      count: data.length
                    });
                    return
                  }
                  
                  // Carrega os dados normalmente
                  commit("SET_LISTA", data);
                  if (status === 200 || status === 201) {
                    resolve({ data, status, needsConfirmation: false });
                  }
                })
                .catch(error => {
                  reject(error)
                })
            })
        }
    }
}


// WEBPACK FOOTER //
// ./src/vuex/modulos/produto-store.js